import { graphql } from '@graphql/__generated'

export const GET_ORGANISATION_BY_NAME = graphql(`
  query getOrganisationByName($name: String!) {
    getOrganisationByName(name: $name) {
      name
      organisationType
      bannerImage
      logoImage
      mainColour
      currency
      percentage
      headerTextOne
      headerTextTwo
      dashboardPopupDoNotShowAgain
      blackBaudIsSet
      url
      merchant
      locations
    }
  }
`)

export const GET_ORGANISATION_PUBLIC_INFO_BY_NAME = graphql(`
  query getOrganisationPublicInfoByName($name: String!) {
    getOrganisationByName(name: $name) {
      name
      bannerImage
      logoImage
      mainColour
      currency
      headerTextOne
      headerTextTwo
      url
    }
  }
`)
